import script from "./OrcamentoProjeto.vue?vue&type=script&setup=true&lang=js"
export * from "./OrcamentoProjeto.vue?vue&type=script&setup=true&lang=js"

import "./OrcamentoProjeto.vue?vue&type=style&index=0&id=fc204c64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc204c64"]])

export default __exports__